// extracted by mini-css-extract-plugin
export default {"vMenu":"index_vMenu_VLUzU","vSelect":"index_vSelect_1csYP","vMenuBox":"index_vMenuBox_C6Gyx","listBox":"index_listBox_tnr8T","vlbackhome":"index_vlbackhome_ZVNzu"};